import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import {
  cond,
  either,
  isNil,
  isEmpty,
  always,
  any,
  complement,
  map,
  split,
  flatten,
  pipe,
  filter,
  defaultTo,
  is,
  allPass,
  test
} from 'ramda'
import withFieldError from 'components/form/with-error'

const isValidTweetId = allPass([
  is(String),
  test(/^\d+$/) // contains only digits
])

export const MatchTweetId = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div className={error && touched && 'has-error'}>
    <TagsInput
      inputProps={{
        placeholder: 'Enter Tweet IDs e.g. 1679066574831992833 ',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

MatchTweetId.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const MatchTweetIdWithError = withFieldError(MatchTweetId)

const noValue = either(isNil, isEmpty)
const hasInvalidTweetIds = any(complement(isValidTweetId))

export const validate = cond([
  [either(noValue, hasInvalidTweetIds), always('Please enter valid Tweet IDs')]
])

export const normalize = pipe(
  map(split(' ')),
  flatten,
  filter(complement(isEmpty))
)

const MatchTweetIdField = ({ name }) => (
  <div>
    <Field
      name={`${name}.tweetIdList`}
      component={MatchTweetIdWithError}
      validate={validate}
      format={defaultTo([])}
      normalize={normalize}
    />
    <Field name={`${name}.primary`} component='input' type='hidden' value />
  </div>
)

MatchTweetIdField.propTypes = {
  name: PropTypes.string
}

export default MatchTweetIdField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/twitter/like-of-any/index.js